
export function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/1e6b684f26e3dbcff2785a427af5447e.jpeg"
                alt="Shantonya Scott Real Estate Advisor"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Your trusted real estate partner in Metro Detroit. Helping families find their perfect home with integrity, expertise, and personalized service.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/shantonya/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-black"></i>
              </a>
              <a href="https://www.instagram.com/shantonyatherealtor/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-black"></i>
              </a>
              <a href="https://www.linkedin.com/in/shantonyascott" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-black"></i>
              </a>
              <a href="https://www.youtube.com/channel/UCptAnnq6T4cA7wtViKJn8qQ" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-black"></i>
              </a>
            </div>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">Services</h5>
            <ul className="space-y-2 text-gray-300">
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Residential Buying</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Home Selling</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">First-Time Buyers</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Investment Properties</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Waterfront Homes</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Luxury Properties</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Relocation Services</button></li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">Service Areas</h5>
            <ul className="space-y-2 text-gray-300">
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Wayne County</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Oakland County</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Macomb County</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Saginaw County</button></li>
              <li><button className="hover:text-yellow-500 transition-colors cursor-pointer">Kent County</button></li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">Contact Info</h5>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center">
                <i className="ri-phone-line mr-3 text-yellow-500"></i>
                <span>(248) 248-4801</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-3 text-yellow-500"></i>
                <span>shantonya@shantonyascott.com</span>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-3 text-yellow-500 mt-1"></i>
                <span>Metro Detroit, Michigan<br />Wayne, Oakland, Macomb, Saginaw &amp; Kent Counties</span>
              </div>
            </div>

            <div className="mt-6">
              <h6 className="font-semibold mb-2">Office Hours</h6>
              <div className="text-sm text-gray-400">
                <div>Mon-Fri: 9AM-6PM</div>
                <div>Saturday: 9AM-3PM</div>
                <div>Sunday: Closed</div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Shantonya Scott Real Estate. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
